import { OmniIconComponent } from "../../../../../shared";

export default function CampaignDetailModal({
    onClose,
    dateRange,
    campaignName,
    mediaPlanSource,
    planVersion,
    syntheticId,
    clientCode,
    productCode,
    lastModified
}) {
    const infoRows = [
        {
            label: 'Campaign Name:',
            value: campaignName
        },
        {
            label: "Start/End date",
            value: dateRange,
        },
        {
            label: "Synthetic ID:",
            value: syntheticId,
        },
        {
            label: "Client Code:",
            value: clientCode,
        },
        {
            label: "Product Code:",
            value: productCode,
        },
        {
            label: 'Media plan source:',
            value: mediaPlanSource,
            iconId: 'omni:informative:connectionSuccess'
        },
        {
            label: 'Plan version',
            value: planVersion
        },
        {
            label: 'Last modified:',
            value: lastModified
        }
    ];

    return <div className="campaign-detail-card-modal modal is-active">
        <div className="modal-body card-content modal-content" slot="body">
            <div className="modal-header">
                Campaign Details
                <button className="tertiary" onClick={onClose}>
                    <OmniIconComponent icon-id="omni:interactive:close" className="close-icon" />
                </button>
            </div>
            <hr />
            <div className="modal-info-rows">
                {infoRows.map((row, index) => (
                    <div key={index} className="info-row">
                        <div className="info-label">{row.label}</div>
                        <div className="info-value-wrapper">
                            <div className="info-value">{row.value}</div>
                            {row.iconId &&
                                <OmniIconComponent
                                    icon-id={row.iconId}
                                />
                            }
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </div>

}